// Mock data for Rooted Landscape & Hardscape Specialist

export const companyInfo = {
  name: "Rooted Landscape and Hardscape Specialist",
  tagline: "Crafting Japanese-Inspired Landscapes with Precision & Artistry",
  phone: "215-534-7848",
  email: "samuels.p85@hotmail.com",
  description: "Specializing in authentic Japanese-style landscape construction, featuring expert flagstone work, strategic boulder placement, and professional large tree moving services."
};

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/r32iksjw_IMG_0420.heic",
  "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/l8ulvcng_IMG_0247.jpeg",
  "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/ay7q2lz0_IMG_0028.jpeg"
];

export const services = [
  {
    id: 1,
    title: "Flagstone Mastery",
    description: "Expert installation of natural flagstone pathways, patios, and terraces. Each stone is carefully selected and placed to create stunning, durable surfaces that blend seamlessly with your landscape.",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/304vrz1k_IMG_0299.jpeg",
    icon: "Mountain"
  },
  {
    id: 2,
    title: "Boulder Placement",
    description: "Strategic placement of boulders to create dramatic focal points and natural-looking landscape features. We specialize in authentic Japanese rock garden design and installation.",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/ay7q2lz0_IMG_0028.jpeg",
    icon: "Hammer"
  },
  {
    id: 3,
    title: "Tree Moving Services",
    description: "Professional hand-digging and transplanting of large, mature trees. We specialize in Japanese maples and specimen trees, ensuring their health and beauty in their new location.",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/5jzeltlz_IMG_0445.jpeg",
    icon: "TreeDeciduous"
  },
  {
    id: 4,
    title: "Japanese Garden Design",
    description: "Authentic Japanese-inspired landscape design incorporating traditional elements like zen gardens, water features, and carefully curated plant selections for year-round beauty.",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/u650fnzi_IMG_0862.jpeg",
    icon: "Leaf"
  }
];

export const galleryItems = [
  // PROJECT 1: Luxury Estate Waterfall & Pond (5 photos)
  {
    id: 1,
    title: "Multi-Tiered Boulder Waterfall & Pond",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/l8ulvcng_IMG_0247.jpeg",
    description: "Spectacular multi-level cascading waterfall with natural stone construction and Japanese maple accent"
  },
  {
    id: 2,
    title: "Cascading Waterfall Detail",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/3rck0x1m_IMG_0236.jpeg",
    description: "Close-up of flowing water over precisely placed tiered boulders creating multiple cascades"
  },
  {
    id: 3,
    title: "Natural Stone Waterfall Construction",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/3nwk5yhd_IMG_0227.jpeg",
    description: "Expert boulder placement creating dramatic multi-level waterfall feature with natural pond integration"
  },
  {
    id: 4,
    title: "Estate Waterfall with Japanese Maple",
    category: "Japanese Garden",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/w8h1mvd3_IMG_0228.jpeg",
    description: "Tiered stone waterfall with mature Japanese maple tree at luxury residential property"
  },
  {
    id: 5,
    title: "Water Feature Construction Progress",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/vi6fjzwv_IMG_0243.jpeg",
    description: "Aerial view of custom pond and waterfall installation showing scale and planning"
  },
  
  // PROJECT 2: Patio with Boulder Water Feature & Fire Pit
  {
    id: 6,
    title: "Flagstone Patio with Boulder Water Feature",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/2etgnac5_RemoteMediaFile_6553866_0_2020_09_03_17_49_26.jpeg",
    description: "Aerial view of custom flagstone patio with integrated boulder water feature and fire pit"
  },
  {
    id: 7,
    title: "Backyard Patio Installation Progress",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/dtptal25_RemoteMediaFile_6553868_0_2020_09_03_17_49_38.jpeg",
    description: "Full landscape renovation featuring flagstone patio and strategic boulder placement"
  },
  {
    id: 8,
    title: "Patio Work in Progress",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/g2jen5px_RemoteMediaFile_6553853_0_2020_08_26_18_02_00.jpeg",
    description: "Work-in-progress aerial showing flagstone patio installation with circular stepping stones"
  },
  
  // PROJECT 3: Circular Patio Front Yard Transformation
  {
    id: 9,
    title: "Complete Front Yard Transformation",
    category: "Japanese Garden",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/v3t0s9xp_DJI_0406.jpeg",
    description: "Aerial view of circular flagstone patio with boulder accents, river rock beds, and fresh plantings"
  },
  
  // PROJECT 4: Curved Stone Steps & Blue-Gray Patio
  {
    id: 10,
    title: "Curved Stone Steps & Patio",
    category: "Japanese Garden",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/u650fnzi_IMG_0862.jpeg",
    description: "Aerial view of curved natural stone steps leading to blue-gray flagstone patio"
  },
  {
    id: 11,
    title: "Blue-Gray Flagstone Patio Detail",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/304vrz1k_IMG_0299.jpeg",
    description: "Close-up of precision flagstone installation with geometric pattern and color variation"
  },
  {
    id: 12,
    title: "Blue-Gray Flagstone Pattern",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/3hguohn8_IMG_1441.jpeg",
    description: "Stunning geometric flagstone pattern with natural color variation in blues and grays"
  },
  
  // PROJECT 5: Multi-Level Contemporary Pathway
  {
    id: 13,
    title: "Modern Multi-Level Stone Pathway",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/c49o7a28_RemoteMediaFile_6553873_0_2020_09_03_17_50_44.jpeg",
    description: "Stunning aerial view of contemporary home with custom flagstone walkway, strategic boulders, and vibrant plantings"
  },
  
  // PROJECT 6: Gravel Pathways with Flagstone Steps
  {
    id: 14,
    title: "Gravel Pathway with Flagstone Steps",
    category: "Japanese Garden",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/tjjyo7un_IMG_1355.jpeg",
    description: "Curved gravel pathway with timber edging, large flagstone steps, and river rock accents"
  },
  {
    id: 15,
    title: "Natural Stone Garden Pathway",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/dbwzmn0b_IMG_1359.jpeg",
    description: "Flowing gravel pathway with flagstone steps, stone borders, and freshly mulched planting beds"
  },
  
  // PROJECT 7: Boulder Retaining Wall
  {
    id: 16,
    title: "Massive Boulder Retaining Wall",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/ay7q2lz0_IMG_0028.jpeg",
    description: "Impressive large-scale boulder retaining wall along driveway with stacked natural stone construction"
  },
  
  // PROJECT 8: Elevated Backyard Patio
  {
    id: 17,
    title: "Elevated Backyard Patio Design",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/xzg048f1_RemoteMediaFile_6553865_0_2020_09_03_17_48_52.jpeg",
    description: "Aerial of spacious flagstone patio with raised garden beds, modern outdoor furniture, and complete landscaping"
  },
  
  // PROJECT 9: Natural Stone Steps Projects
  {
    id: 18,
    title: "Curved Natural Stone Steps",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/0pxakf19_IMG_0234.jpeg",
    description: "Flowing stone steps with river rock borders and boulder accents leading to patio area"
  },
  {
    id: 19,
    title: "Natural Stone Steps with Boulder Edging",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/nzxaxibl_IMG_0426.jpeg",
    description: "Hand-placed natural stone steps with river rock and boulder borders"
  },
  {
    id: 20,
    title: "Stone Steps Installation in Progress",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/qb4ot2ui_IMG_0232.jpeg",
    description: "Natural stone steps under construction with strategic boulder placement and river rock"
  },
  
  // PROJECT 10: Front Entry Flagstone Projects
  {
    id: 21,
    title: "Elegant Front Entry Flagstone",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/iokrt7o9_IMG_0014.jpeg",
    description: "Custom flagstone entryway with mixed blue, brown, and gray tones"
  },
  {
    id: 22,
    title: "Front Door Flagstone Landing",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/htrxkfrj_IMG_0100.jpeg",
    description: "Beautiful flagstone entryway with natural color variation and precise jointing"
  },
  
  // PROJECT 11: Pathways & Landscape Integration
  {
    id: 23,
    title: "Flagstone Shed Pathway",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/9hx0hjdn_IMG_0358.jpeg",
    description: "Detailed flagstone pathway leading to shed with ornamental grasses and landscape integration"
  },
  {
    id: 24,
    title: "Curved Pathway with Landscape Beds",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/x9n3ejm8_IMG_0398.jpeg",
    description: "Flowing flagstone pathway with fresh mulched planting beds"
  },
  
  // PROJECT 12: Tree Moving & Installation
  {
    id: 25,
    title: "Large Evergreen Tree Moving",
    category: "Tree Installation",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/5jzeltlz_IMG_0445.jpeg",
    description: "Professional hand-digging and moving of massive specimen evergreen with expertly wrapped rootball"
  },
  {
    id: 26,
    title: "Custom Bamboo Fence Installation",
    category: "Hardscape",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/1k4xgxc1_IMG_0969.jpeg",
    description: "Professional bamboo fencing installation - natural privacy screening with expert craftsmanship"
  },
  {
    id: 27,
    title: "First Hand Dug Trees of the Year",
    category: "Tree Installation",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/degpez6e_IMG_1034.heic",
    description: "Spring tree moving season - professional hand-digging and transplanting of specimen trees"
  },
  {
    id: 29,
    title: "Flagstone Patio Restoration & Repair",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/ums6pdop_HOVER_20250902_1775495110952.jpeg",
    description: "Complete flagstone repair around pool and steps - restored crumbling patio to like-new condition"
  },
  {
    id: 30,
    title: "Professional Landscape Project",
    category: "Flagstone Work",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/h1uoh0e3_IMG_1701.heic",
    description: "Custom landscape installation showcasing expert craftsmanship"
  },
  
  // PROJECT 13: Craftsman at Work & Process Shots
  {
    id: 28,
    title: "Craftsman at Work - Stone Placement",
    category: "Boulder Placement",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/lfbfkau7_IMG_1354.jpeg",
    description: "Hand-placing stones for custom water feature and rock borders - showcasing authentic craftsmanship"
  },
  
  // PROJECT 14: Arborvitae Privacy Screen Installation (2 photos)
  {
    id: 31,
    title: "Arborvitae Privacy Screen Planting",
    category: "Planting & Installation",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/ebk7j0uq_HOVER_20260410_1775850879485.jpeg",
    description: "Professional arborvitae installation creating a natural privacy screen along property entrance"
  },
  {
    id: 32,
    title: "Arborvitae Landscape Installation",
    category: "Planting & Installation",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/7cunwcjn_HOVER_20260410_1775850879589.jpeg",
    description: "Complete arborvitae planting with professional site preparation and mulching"
  },
  
  // PROJECT 15: Princeton Landscape Project
  {
    id: 33,
    title: "Princeton Landscape Installation",
    category: "Landscape Design",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/k0x5lydr_IMG_0067.heic",
    description: "Professional landscape construction project in Princeton featuring expert installation and design"
  },
  
  // PROJECT 16: Custom Waterfall Features (2 photos)
  {
    id: 34,
    title: "Natural Stone Waterfall",
    category: "Water Features",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/0zgtrf90_IMG_0328.heic",
    description: "Custom-built natural stone waterfall with expert boulder placement and water flow design"
  },
  {
    id: 35,
    title: "Cascading Waterfall Installation",
    category: "Water Features",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/1ted1ya1_IMG_0331.heic",
    description: "Professional waterfall construction featuring natural stone cascades and landscaping integration"
  },
  
  // PROJECT 17: Custom Pool & Tiered Waterfall Feature (2 photos)
  {
    id: 36,
    title: "Custom Pool with Multi-Tier Waterfall",
    category: "Water Features",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/hsmdmqy6_IMG_0345.jpeg",
    description: "Stunning custom pool featuring multi-tiered natural stone waterfall, professional excavation and boulder placement with white stone edging"
  },
  {
    id: 37,
    title: "Natural Stone Pool Waterfall Feature",
    category: "Water Features",
    image: "https://customer-assets.emergentagent.com/job_boulder-tree-work/artifacts/pqbrtyqc_IMG_0328.heic",
    description: "Major water feature project showcasing expert hardscape construction and natural stone waterfall installation"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Bucks County, PA",
    text: "The flagstone work in our backyard is absolutely stunning. Every stone was placed with such care and precision. It's like having a piece of art in our garden.",
    rating: 5
  },
  {
    id: 2,
    name: "James Chen",
    location: "Montgomery County, PA",
    text: "They moved three mature Japanese maples to our property, and all three are thriving. The attention to detail and knowledge of proper tree handling was impressive.",
    rating: 5
  },
  {
    id: 3,
    name: "Linda Rodriguez",
    location: "Philadelphia, PA",
    text: "Our Japanese-inspired garden exceeded all expectations. The boulder placement creates such a serene atmosphere. Highly recommend for authentic landscape work.",
    rating: 5
  }
];